import { metersToFeet, getFormattedNumber } from "./utils";
export default class STWiremapGenerator {
  chartMeasurementUnit = "meters";

  static generateTexts(data, fullWidth, marginHor, lineGap, lineWidth) {
    let textsData = [];

    // textsData.push({
    //   text: this.translate("wiremap_mh"),
    //   x: 0,
    //   y: lineGap - lineGap / 4,
    //   fontSize: lineWidth * 1.2,
    //   textAnchor: "start"
    // });
    // textsData.push({
    //   text: this.translate("wiremap_rh"),
    //   x: fullWidth,
    //   y: lineGap - lineGap / 4,
    //   fontSize: lineWidth * 1.2,
    //   textAnchor: "end"
    // });
    data.forEach((d, i) => {
      textsData.push({
        text: data[i],
        x: 0,
        y: (i + 1) * lineWidth + (i + 1) * lineGap + lineWidth / 2,
        fontSize: parseInt(lineWidth * 1.5, 10),
        textAnchor: "start"
      });
      // textsData.push({
      //   //text: data[i],
      //   x: fullWidth,
      //   y: (i + 1) * lineWidth + (i + 1) * lineGap + lineWidth / 2,
      //   //fontSize: parseInt(lineWidth * 1.5, 10),
      //   textAnchor: "end"
      // });
    });
    return textsData;
  }

  static generateCheckBox(data, fullWidth, marginHor, lineGap, lineWidth) {
    let checkboxData = [];

    data.forEach((d, i) => {
      checkboxData.push({
        pin: data[i],
        x: fullWidth,
        y: (i + 1) * lineWidth + (i + 1) * lineGap + lineWidth / 2,

        textAnchor: "end"
      });
      // textsData.push({
      //   //text: data[i],
      //   x: fullWidth,
      //   y: (i + 1) * lineWidth + (i + 1) * lineGap + lineWidth / 2,
      //   //fontSize: parseInt(lineWidth * 1.5, 10),
      //   textAnchor: "end"
      // });
    });
    return checkboxData;
  }

  static generateHeadTail(
    data,
    fullWidth,
    marginHor,
    width,
    lineGap,
    lineWidth
  ) {
    let lines = data.Details;
    let headLinesData = [];
    let tailLinesData = [];

    for (let i in lines) {
      let curline = lines[i];
      let pin = parseInt(curline.DHPin, 10);

      // if (curline.DHPin === "S") {
      //   pin = 9;
      // } else {
      //   pin = parseInt(pin, 10);
      // }

      headLinesData.push({
        dash: false,
        pin: pin,
        line: [
          {
            x: 0 + marginHor,
            y: lineGap * pin + lineWidth * pin
          },
          {
            x: width + marginHor,
            y: lineGap * pin + lineWidth * pin
          }
        ]
      });

      tailLinesData.push({
        dash: false,
        pin: pin,
        line: [
          {
            x: fullWidth - marginHor - width,
            y: lineGap * pin + lineWidth * pin
          },
          {
            x: fullWidth - marginHor,
            y: lineGap * pin + lineWidth * pin
          }
        ]
      });
    }
    return {
      headlines: headLinesData,
      taillines: tailLinesData
    };
  }

  static generateLines(data, fullWidth, marginHor, lineGap, lineWidth) {
    let lines = data.Details;
    let wireLength = data.RefLength;
    let totalwidth = fullWidth - marginHor * 2;

    let linesData = [];
    let shortLinesData = [];
    let openLinesData = [];
    let gridSize = totalwidth / 12;
    for (let i in lines) {
      let curline = lines[i];
      let pin = curline.DHPin;

      if (curline.DHPin === "S") {
        pin = 9;
      } else {
        pin = parseInt(pin, 10);
      }

      //dash line or solid line
      let isDashed = false;
      if (pin !== 9 && pin % 2) {
        isDashed = true;
      }

      //If Split
      if (curline.IsUndefined === false && curline.IsSplit === true) {
        linesData.push({
          dash: isDashed,
          pin: pin,
          line: [
            {
              x: 0 + marginHor,
              y: lineGap * pin + lineWidth * pin
            },
            {
              x: gridSize * 2 + marginHor,
              y: lineGap * pin + lineWidth * pin
            }
          ]
        });
        linesData.push({
          dash: false,
          pin: pin,
          lineColor: "red",
          line: [
            {
              x: gridSize * 2 + marginHor,
              y: lineGap * pin + lineWidth * pin
            },
            {
              x: gridSize * 10 + marginHor,
              y: lineGap * pin + lineWidth * pin
            }
          ]
        });
        linesData.push({
          dash: isDashed,
          pin: pin,
          line: [
            {
              x: gridSize * 10 + marginHor,
              y: lineGap * pin + lineWidth * pin
            },
            {
              x: gridSize * 12 + marginHor,
              y: lineGap * pin + lineWidth * pin
            }
          ]
        });
      }
      //FOR STRAIGHT
      else if (curline.IsUndefined === false && curline.IsThru === true) {
        linesData.push({
          dash: isDashed,
          pin: pin,
          line: [
            {
              x: 0 + marginHor,
              y: lineGap * pin + lineWidth * pin
            },
            {
              x: gridSize * 12 + marginHor,
              y: lineGap * pin + lineWidth * pin
            }
          ]
        });
      }
      //FOR CROSS
      else if (
        curline.IsUndefined === false &&
        (curline.IsCross === true || curline.IsReverse === true) &&
        curline.CrossPin !== null
      ) {
        linesData.push({
          dash: isDashed,
          pin: pin,
          line: [
            {
              x: 0 + marginHor,
              y: lineGap * pin + lineWidth * pin
            },
            {
              x: gridSize * 3 + marginHor,
              y: lineGap * pin + lineWidth * pin
            },
            {
              x: gridSize * 9 + marginHor,
              y:
                lineGap * parseInt(curline.CrossPin, 10) +
                lineWidth * parseInt(curline.CrossPin, 10)
            },
            {
              x: gridSize * 12 + marginHor,
              y:
                lineGap * parseInt(curline.CrossPin, 10) +
                lineWidth * parseInt(curline.CrossPin, 10)
            }
          ]
        });
      }
      //FOR OPEN
      else if (curline.IsUndefined === false && curline.IsOpen === true) {
        let distanceOpen = curline.DistanceToOpen;

        let openPositionRatioInLength = distanceOpen / wireLength;
        let openPositionInWidth = totalwidth * openPositionRatioInLength;

        let mHSide = openPositionInWidth - gridSize / 2;
        if (mHSide < 0) {
          mHSide = openPositionInWidth;
        }

        let rHSide = openPositionInWidth + gridSize / 2;
        if (rHSide > totalwidth) {
          rHSide = openPositionInWidth;
        }

        linesData.push({
          dash: isDashed,
          pin: pin,
          line: [
            {
              x: 0 + marginHor,
              y: lineGap * pin + lineWidth * pin
            },
            {
              x: mHSide + marginHor,
              y: lineGap * pin + lineWidth * pin
            }
          ]
        });
        linesData.push({
          dash: isDashed,
          pin: pin,
          line: [
            {
              x: rHSide + marginHor,
              y: lineGap * pin + lineWidth * pin
            },
            {
              x: gridSize * 12 + marginHor,
              y: lineGap * pin + lineWidth * pin
            }
          ]
        });
        openLinesData.push({
          dash: isDashed,
          pin: pin,
          line: [
            {
              x: mHSide + marginHor - lineWidth / 2,
              y: lineGap * pin + lineWidth * pin - lineWidth
            },
            {
              x: mHSide + marginHor,
              y: lineGap * pin + lineWidth * pin - lineWidth / 2
            },
            {
              x: mHSide + marginHor,
              y: lineGap * pin + lineWidth * pin + lineWidth / 2
            },
            {
              x: mHSide + marginHor - lineWidth / 2,
              y: lineGap * pin + lineWidth * pin + lineWidth
            }
          ]
        });
        openLinesData.push({
          dash: isDashed,
          pin: pin,
          line: [
            {
              x: rHSide + marginHor + lineWidth / 2,
              y: lineGap * pin + lineWidth * pin - lineWidth
            },
            {
              x: rHSide + marginHor,
              y: lineGap * pin + lineWidth * pin - lineWidth / 2
            },
            {
              x: rHSide + marginHor,
              y: lineGap * pin + lineWidth * pin + lineWidth / 2
            },
            {
              x: rHSide + marginHor + lineWidth / 2,
              y: lineGap * pin + lineWidth * pin + lineWidth
            }
          ]
        });
      } else if (
        curline.IsUndefined === true &&
        curline.IsThru === true &&
        pin === 9
      ) {
        //Special Case for Shield Line
        linesData.push({
          dash: false,
          pin: pin,
          //"lineWidth": lineWidth / 4,
          //"lineColor": "red",
          line: [
            {
              x: 0 + marginHor,
              y: lineGap * pin + lineWidth * pin
            },
            {
              x: gridSize * 12 + marginHor,
              y: lineGap * pin + lineWidth * pin
            }
          ]
        });
      }

      //Short
      if (curline.IsShort) {
        let shortpins = curline.ShortPins;
        if (shortpins) {
          for (let i in shortpins) {
            let targetPin = shortpins[i].Pin;

            if (targetPin === "S") {
              targetPin = 9;
            } else {
              targetPin = parseInt(targetPin, 10);
            }
            let shortDH = shortpins[i].ShortDH;
            if (shortDH === null) {
              shortDH = wireLength - shortpins[i].ShortRH;
            }
            let shortPositionRatioInLength = shortDH / wireLength;
            let shortPositionInWidth =
              (fullWidth - marginHor * 2) * shortPositionRatioInLength;
            shortLinesData.push({
              marker: true,
              line: [
                {
                  x: shortPositionInWidth + marginHor,
                  y: lineGap * pin + lineWidth * pin
                },
                {
                  x: shortPositionInWidth + marginHor,
                  y: lineGap * targetPin + lineWidth * targetPin
                }
              ]
            });
          }
        }
      }
    }

    return {
      lines: linesData,
      shortlines: shortLinesData,
      openlines: openLinesData
    };
  }

  static generateTableData(data, chartMeasurementUnit) {
    let lines = data.Details;
    let wireLength = data.RefLength;

    lines.sort((a, b) => a.DHPin - b.DHPin);

    let linesData = [];

    for (let i in lines) {
      let curline = lines[i];
      if (
        curline.IsUndefined === false &&
        (curline.IsReverse ||
          curline.IsCross ||
          curline.IsOpen ||
          curline.IsShort ||
          curline.IsSplit)
      ) {
        let curlineData = {
          main: curline.DHPin,
          faults: []
        };

        if (curline.IsSplit) {
          curlineData.faults.push(this.translate("wiremap_split"));
        }
        if (curline.IsCross || curline.IsReverse) {
          if (curline.CrossPin) {
            curlineData.remote = curline.CrossPin;
            curlineData.faults.push(
              curline.IsCross
                ? this.translate("wiremap_cross")
                : this.translate("wiremap_reverse")
            );
          }
        }
        if (curline.IsOpen) {
          curlineData.faults.push(
            this.translate("wiremap_open") +
              " @ " +
              (curline.DistanceToOpen
                ? this.convertMeasurementUnit(curline.DistanceToOpen)
                : this.convertMeasurementUnit(0))
          );
        }
        if (curline.IsShort) {
          let shortpins = curline.ShortPins;
          if (shortpins) {
            for (let j in shortpins) {
              if (shortpins[j].Pin === "S" || curline.DHPin === "S") {
                curlineData.faults.push(
                  shortpins[j].Pin + " " + this.translate("wiremap_short")
                );
              } else if (shortpins[j].ShortDH === 0) {
                curlineData.faults.push(
                  shortpins[j].Pin +
                    " " +
                    this.translate("wiremap_short") +
                    " @ " +
                    this.translate("wiremap_mh") +
                    " " +
                    this.convertMeasurementUnit(shortpins[j].ShortDH)
                );
              } else if (shortpins[j].ShortRH === 0) {
                curlineData.faults.push(
                  shortpins[j].Pin +
                    " " +
                    this.translate("wiremap_short") +
                    " @ " +
                    this.translate("wiremap_rh") +
                    " " +
                    this.convertMeasurementUnit(shortpins[j].ShortRH)
                );
              } else {
                let shortDH =
                  shortpins[j].ShortDH !== null
                    ? shortpins[j].ShortDH
                    : wireLength - shortpins[j].ShortRH;
                let shortRH =
                  shortpins[j].ShortRH !== null
                    ? shortpins[j].ShortRH
                    : wireLength - shortpins[j].ShortDH;
                if (shortDH <= shortRH || shortpins[j].ShortRH == null) {
                  curlineData.faults.push(
                    shortpins[j].Pin +
                      " " +
                      this.translate("wiremap_short") +
                      " @ " +
                      this.translate("wiremap_mh") +
                      " " +
                      this.convertMeasurementUnit(shortDH)
                  );
                } else {
                  curlineData.faults.push(
                    shortpins[j].Pin +
                      " " +
                      this.translate("wiremap_short") +
                      " @ " +
                      this.translate("wiremap_rh") +
                      " " +
                      this.convertMeasurementUnit(shortRH)
                  );
                }
              }
            }
          }
        }
        linesData.push(curlineData);
      }
    }
    return {
      lines: linesData,
      nodata: !linesData.length
    };
  }
  static getLineInfo(details, line) {
    if (line === 9 || line === "9") {
      line = "S";
    }
    for (let i in details) {
      if (details[i].DHPin === line.toString()) {
        return details[i];
      }
    }
  }

  static convertMeasurementUnit(val) {
    if (
      this.chartMeasurementUnit === "meters" ||
      this.chartMeasurementUnit === "meter"
    ) {
      return (
        getFormattedNumber(val) +
        " " +
        this.translate("chart_measurement_unit_meter_sort")
      );
    } else {
      return `${metersToFeet(val)}`;
    }
  }
  static setChartMeasurementUnit(chartMeasurementUnit) {
    this.chartMeasurementUnit = chartMeasurementUnit;
  }

  static setTranslate(translate) {
    this.translate = translate;
  }
}
